/*@flow*/
import type { Node } from 'react'; /** @jsx jsx */
import { useReducer, Fragment } from 'react';
import { Global, css, jsx } from '@emotion/core';
import LTContext from './LTContext';
import mkState from './mkState';
import reducer from './reducer';
import useLoadedPanel from './useLoadedPanel';
import useLayerLoader from './useLayerLoader';
import useLayerObserver from './useLayerObserver';
import useLayerActivator from './useLayerActivator';
import LTContainer from './LTContainer';
import dot from './dot';

export function Component(): Node {
  useLayerObserver();
  useLayerLoader();
  useLayerActivator();
  useLoadedPanel();

  return (
    <Fragment>
      <Global
        styles={css(`
        :root { --primary2: #1779D2; }
        .text-link { color: #049D8D !important; }
        .text-muted-2 { color: #6c757d !important; }
        .green-dot { ${dot()} }
        .mt-2dot5 { margin-top: 2.5rem !important; }
        * { font-family: 'Open Sans', 'Helvetica Neue', 'Helvetica', Arial, sans-serif; }
      `)}
      />
      <LTContainer />
    </Fragment>
  );
}

export function Container({
  children,
  ...rest
}: {
  children: ?React$Node,
}): any {
  const initState = mkState(rest || {});
  const [s, dispatch] = useReducer(reducer, initState);
  const ctx = { state: s, dispatch };
  return (
    <LTContext.Provider value={ctx}>{children || null}</LTContext.Provider>
  );
}

function ContainedComponent() {
  return (
    <Container>
      <Component />
    </Container>
  );
}

export default (ContainedComponent: any);
